import type { ReactElement } from 'react'

interface YourLicensesOptionProps {
  title: string
  description: string
  button: ReactElement
}

export const YourLicensesOption = (props: YourLicensesOptionProps) => {
  const { title, description, button } = props

  return (
    <div className="flex justify-between mt-10 mb-8 items-center">
      <div className="flex flex-col gap-2">
        <h4 className="text-xl font-semibold text-text-default">{title}</h4>
        <p className="text-sm font-medium text-text-sub">{description}</p>
      </div>
      {button}
    </div>
  )
}
